import { createSlice } from '@reduxjs/toolkit';
import { RequestStatus } from '../interface';
import { getAccountsDataThunk } from '../thunks/accounts-data.thunk';
export const accountsDataSliceName = 'accountsData';
export const initialAccountsDataState = {
  accounts: [],
  pinnedAccountIds: [],
  status: RequestStatus.IDLE,
  error: null
};
export const {
  reducer: accountsDataReducer,
  actions: accountsDataActions
} = createSlice({
  name: accountsDataSliceName,
  initialState: initialAccountsDataState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getAccountsDataThunk.pending, state => {
      state.status = RequestStatus.LOADING;
    });
    builder.addCase(getAccountsDataThunk.fulfilled, (state, action) => Object.assign({}, state, {
      status: RequestStatus.SUCCESS,
      accounts: action.payload.basicAccounts,
      pinnedAccountIds: action.payload.pinnedAccountIds
    }));
    builder.addCase(getAccountsDataThunk.rejected, (state, action) => {
      var _action$payload, _action$payload2;
      return Object.assign({}, state, {
        status: RequestStatus.ERROR,
        error: action.error,
        accounts: ((_action$payload = action.payload) === null || _action$payload === void 0 ? void 0 : _action$payload.basicAccounts) || [],
        pinnedAccountIds: ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.pinnedAccountIds) || []
      });
    });
  }
});